// Returns the current year string: eg '2019'
function getCurrentYear() {
  return new Date().getFullYear()
}

export default getCurrentYear
